<template>
  <v-container class="pt-0" style="background-color: white" fluid>
    <v-row no-gutters justify="center">
      <v-col cols="12" md="6" justify="center" align="center">
        <span style="font-size: 30px; color: #616161">
          <v-icon large class="pr-1 pb-2">join_inner</v-icon>
          Periodos a revaluar</span>
      </v-col>
    </v-row>
    <v-row class="mt-2 mb-2">
      <v-toolbar flat>
        <v-col cols="3">
          <search-header class="mt-2" @dataFilters="changeBusiness($event)" :show_weeks="false" :show_location="false"
            :show_department="false" :show_refresh="false" :type="false" />
        </v-col>
        <v-col cols="2">

          <v-autocomplete v-model="current_calendar" :items="calendars" label="Calendario" item-text="name"
            item-value="accounting_calendar_id" @change="showPeriods" outlined dense hide-details></v-autocomplete>
        </v-col>

        <v-spacer> </v-spacer>
        <v-text-field class="mt-3" dense label="Buscar.." v-model="search" append-icon="search" single-line hide-details
          outlined></v-text-field>
        <v-spacer></v-spacer>
      </v-toolbar>
    </v-row>
    <v-card flat class="pt-3">
      <v-data-table :v-if="loading" item-key="accounting_period_id" :headers="headers" :items="periods" :search="search"
        height="65vh" loading-text="Cargando datos..." dense sort-by="accounting_period_id" fixed-header
        :items-per-page="60">
        <template v-slot:top>

        </template>

        <template v-slot:[`item.diary_book_id`]="{ item }">
          <v-hover v-slot="{ hover }">
            <span v-if="item.diary_book_id != null" @click="showEntry(item.diary_book_id)"
              class="primary--text font-weight-normal text-truncate font-weight-semibold" :style="{
                color: hover ? 'red' : 'black',
                cursor: hover ? 'pointer' : '',
                'text-decoration': hover ? 'underline' : '',
              }">
              {{ item.diary_book_id }}
            </span>
          </v-hover>
        </template>
        <template v-slot:[`item.date_from`]="{ item }">
          <span>{{ getDate(item.date_from) }}</span>
        </template>
        <template v-slot:[`item.date_to`]="{ item }">
          <span>{{ getDate(item.date_to) }}</span>
        </template>
        <template v-slot:[`item.actions`]="{ item }">
          <v-tooltip v-if="!item.chart_of_account_id" top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn @click="editItem(item)" icon>
                <v-icon v-bind="attrs" v-on="on" color="primary">
                  refresh
                </v-icon>
              </v-btn>
            </template>
            <span>Revaluar</span>
          </v-tooltip>
          <v-tooltip v-else top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn icon>
                <v-icon v-bind="attrs" v-on="on" color="red"> remove </v-icon>
              </v-btn>
            </template>
            <span>Revaluar</span>
          </v-tooltip>
        </template>
        <template v-slot:no-data>
          <v-row justify="center" class="pt-10">
            <v-icon size="80px">token</v-icon>
          </v-row>
        </template>
      </v-data-table>
    </v-card>
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span class="text-h5 primary--text">Revaluar periodo</span>
          <v-spacer></v-spacer>
          <v-icon @click="dialog = false">close</v-icon>
        </v-card-title>
        <v-divider></v-divider>

        <v-card-text>
          <v-container>
            <v-row justify="center" class="pa-4 pb-4">
              <span class="text-h6"><b>Periodo {{ editedItem.accounting_period_id }}</b></span>
            </v-row>
            <v-row justify="center" class="pa-4 pb-1">
              <span class="mx-2"><b>Desde: </b></span>
              {{ getDate(editedItem.date_from) }}
            </v-row>

            <v-row justify="center" class="pa-4 mb-8">
              <span class="mx-2"><b>Hasta:</b></span>
              {{ getDate(editedItem.date_to) }}
            </v-row>
          </v-container>
        </v-card-text>

        <v-card-actions class="mt-n10">
          <v-row no-gutters justify="center">
            <v-spacer></v-spacer>
            <v-btn @click="dialog = false" outlined text> Cancelar </v-btn>
            <v-spacer></v-spacer>
            <v-btn :loading="loading" @click="save" dark color="black"> Revaluar </v-btn>
            <v-spacer></v-spacer>
          </v-row>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
import moment from "moment";
export default {
  data: () => ({
    search: null,
    periods: [],
    calendars: [],
    editedIndex: -1,
    dialog: false,
    editedItem: {},
    loading: false,
    current_calendar: null,
    loading: false,
    item_loading: null,
    lastData: null,

    headers: [
      { text: "Id", value: "accounting_period_id" },
      { text: "Desde", value: "date_from" },
      { text: "Hasta", value: "date_to" },
      { text: "Referencia libro", value: "diary_book_id" },

      { text: "Opciones", value: "actions", sortable: false, align: "center" },
    ],
  }),

  // watch: {},
  methods: {
    changeBusiness(filters) {
      this.lastData = filters;
      this.periods = [];
      this.current_calendar = null;
      this.getCalendars(filters);
    },
    getDate(date) {
      moment.locale("es");

      let newDate = moment(date).format("DD-MMMM-YYYY").toString();
      return newDate;
    },
    async getCalendars(filters) {
      if (filters.business == null || filters.business == 0) {
        return;
      }
      this.calendars = []


      const data = await this.api_Post(
        "accounting/calendar_periods_revaluate",
        {
          id: filters.business,
        }
      );
      let result = await data.json();
      this.calendars = result.sort((a, b) => a.accounting_calendar_id - b.accounting_calendar_id);

      if (this.calendars.length > 0) {
        this.current_calendar = this.calendars[this.calendars.length - 1].accounting_calendar_id;
        this.showPeriods(this.current_calendar);
      }

      this.lastData = filters;
    },
    async save() {

      this.loading = true
      let lastCalendar = this.current_calendar
      const data = await this.api_Post(
        "accounting/revaluate_period",
        {
          user_id: this.$store.state.auth.user.user.user_id,
          business_unit_id: this.lastData.business,
          accounting_calendar_period_id: this.editedItem.id
        }
      );
      let result = await data.json();
      if (result) {
        this.dialog = false;

        await this.getCalendars(this.lastData);
        this.showPeriods(lastCalendar);
      }
      else {
        this.$toast.error("Error al revaluar el periodo");
      }
      this.loading = false
    },
    editItem(item) {
      this.editedIndex = this.periods.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },
    showEntry(id) {
      let route = this.$router.resolve({
        name: "ViewRevaluation",
        params: { id: id },
      });
      window.open(route.href);
    },
    showPeriods(id) {

      this.periods = [];
      this.loading = true;
      let data = this.calendars.find(
        (element) => element.accounting_calendar_id == id
      );

      this.periods = data.periods;
      this.loading = false
    },

  },
};
</script>
